import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable, faArrowRight, faUsers, faTasks, faTachometer, faEye, faPlus, faTrashCan, faVideo, faPencil, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import { useRecoilState } from 'recoil';

import { EQUIPMENT_OPTIONS } from "../../../Constants/FieldOptions";
import { getSessionDetailAPI } from "../../../API/Session";
import { getSelectedOptions } from "../../../Helpers/selectHelper";
import { putSessionUpdateAPI } from "../../../API/Session";
import FormErrorBox from "../../Reusable/FormErrorBox";
import FormInputField from "../../Reusable/FormInputField";
import FormTextareaField from "../../Reusable/FormTextareaField";
import FormMultiSelectField from "../../Reusable/FormMultiSelectField";
import FormRadioField from "../../Reusable/FormRadioField";
import PageLoadingContent from "../../Reusable/PageLoadingContent";
import { getSessionListAPI, deleteSessionAPI } from "../../../API/Session";
import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../../AppState";


function UserSessionDetailForVideoSection() {
    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user, setUser] = useRecoilState(userDetailState);

    ////
    //// URL Parameters.
    ////

    const { uid, sid } = useParams()

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [session, setSession] = useState({});
    const [selectedVideoSectionForDeletion, setSelectedVideoSectionForDeletion] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionDetailForVideoSectionSuccess(response){
        console.log("onSessionDetailForVideoSectionSuccess: Starting...");
        setSession(response);
    }

    function onSessionDetailForVideoSectionError(apiErr) {
        console.log("onSessionDetailForVideoSectionError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionDetailForVideoSectionDone() {
        console.log("onSessionDetailForVideoSectionDone: Starting...");
        setFetching(false);
    }

    function onVideoSectionDeleteSuccess(response){
        console.log("onVideoSectionDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Video section deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        // fetchList();
    }

    function onVideoSectionDeleteError(apiErr) {
        console.log("onVideoSectionDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onVideoSectionDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onVideoSectionDeleteDone() {
        console.log("onVideoSectionDeleteDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSelectVideoSectionForDeletion = (e, videoSection) => {
        console.log("onSelectVideoSectionForDeletion", videoSection);
        setSelectedVideoSectionForDeletion(videoSection);
    }

    const onDeselectVideoSectionForDeletion = (e) => {
        console.log("onDeselectVideoSectionForDeletion");
        setSelectedVideoSectionForDeletion("");
    }

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick", selectedVideoSectionForDeletion); // For debugging purposes only.

        //
        // The following code will remove the data from the JSON.
        //

        let vsIndex;
        for (let videoSectionIndex in session.videoSections) {
            let vs = session.videoSections[videoSectionIndex];
            if (vs.name === selectedVideoSectionForDeletion.name) {
                vsIndex = videoSectionIndex;
                break;
            }
        }
        console.log("videoSectionIndex:", vsIndex);
        session.videoSections.splice(vsIndex, 1);

        // Remove from state.
        setSelectedVideoSectionForDeletion("");

        // Update the session.
        console.log("onSubmitClick, session:", session);
        putSessionUpdateAPI(session, onSessionUpdateSuccess, onSessionUpdateError, onSessionUpdateDone);
    }

    function onSessionUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Session updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);
    }

    function onSessionUpdateError(apiErr) {
        console.log("onSessionUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionUpdateError: Delayed for 2 seconds.");
            console.log("onSessionUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionUpdateDone() {
        console.log("onSessionUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.

            setFetching(true);
            getSessionDetailAPI(
                sid,
                onSessionDetailForVideoSectionSuccess,
                onSessionDetailForVideoSectionError,
                onSessionDetailForVideoSectionDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Sessions)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Video Sections)</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Detail (Sessions)</Link></li>
                        </ul>
                    </nav>

                    {/* Modals */}
                    {/* None */}

                    {/* Page */}
                    <nav class="box">

                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session - {user.firstName} {user.lastName}</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/user/${uid}/session/${sid}/video-sections/add`} class="button is-small is-success is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPlus} />&nbsp;New Video Section
                                </Link>
                            </div>
                        </div>

                        {/* Tab Navigation */}
                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link to={`/user/${uid}/session/${sid}`}>Detail</Link>
                                </li>
                                {(() => {
                                    // Defensive code: Only run this if we have data.
                                    if (session !== undefined && session !== null && session !== "") {
                                        // Show based on session type.
                                        switch (session.sessionType) {
                                            case "base": return (
                                                <li>
                                                    <Link class="is-active" to={`/user/${uid}/session/${sid}/video-sections`}><strong>Video Sections</strong></Link>
                                                </li>
                                            );
                                            case "sleep": return (
                                                <li>
                                                    <Link to={`/user/${uid}/session/${sid}/sleep-questions`}>Sleep Questions</Link>
                                                </li>
                                            );
                                            case "breath": return (
                                                <li>
                                                    <Link to={`/user/${uid}/session/${sid}/breathwork-options`}>Breathing Options</Link>
                                                </li>
                                            );
                                            default: return null;
                                        };
                                    }
                                    // In case we don't have a session template.
                                    return null;
                                })()}
                            </ul>
                        </div>

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                <div class="columns">

                                    <div class="column">

                                        <div class="columns">
                                            <div class="column">
                                                <p class="subtitle"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Sections</p>
                                            </div>
                                            <div class="column has-text-right">

                                            </div>
                                        </div>

                                        {session && session.videoSections && session.videoSections.length > 0
                                            ? <>
                                                {session.videoSections.map((object, i) => <VideoSectionRow sid={sid} uid={uid} obj={object} i={i} key={i} onSelectVideoSectionForDeletion={onSelectVideoSectionForDeletion} />)}
                                            </>
                                            : <>
                                                <div class="hero-body">
                                                  <p class="title">
                                                      <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No data
                                                  </p>
                                                  <p class="subtitle">
                                                      No data. <b><Link to={`/user/${uid}/session/${sid}/video-sections/add`}>Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started creating your first video section.
                                                  </p>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </>
                        }

                        <div class="columns">
                            <div class="column is-half">
                                <Link to={`/user/${uid}/sessions`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to User Sessions</Link>
                            </div>
                            <div class="column is-half has-text-right">
                                <Link to={`/user/${uid}/session/${sid}/video-sections/add`} class="button is-success is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;New Video Section</Link>
                            </div>
                        </div>
                    </nav>
                </section>
            </div>
        </>
    );
}

function VideoSectionRow(props) {
    const { uid, sid, obj, i, onSelectVideoSectionForDeletion } = props;
    if (obj === undefined) {
        return null;
    }
    const { name, detail, exercises } = obj;

    console.log(name, detail, exercises);
    return (
        <div class="box">
            {/*
                ##################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                ##################################################################
            */}
            <div class="is-hidden-touch" >
                <div className="columns">
                    <div className="column is-half">
                        <div class="is-pulled-left">
                            <p class="title is-5">{name}</p>
                            <p class="subtitle is-6">{detail}</p>
                        </div>
                    </div>
                    <div className="column is-half">
                        <div class="is-pulled-right">
                            <Link to={`/user/${uid}/session/${sid}/video-section/${i}`} class="button is-primary"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                            {/*
                            <Link to={`/user/${uid}/session/${sid}/video-section/${i}/edit`} class="button is-warning"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                            <button onClick={(e, ses) => onSelectVideoSectionForDeletion(e, obj)} class="button is-danger"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                             */}
                        </div>
                    </div>
                </div>
            </div>

            {/*
                ###########################################################################
                EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                ###########################################################################
            */}
            <div class="is-hidden-desktop mb-5">
                <strong>Name:</strong>&nbsp;{name}
                <br />
                <br />
                <strong>Detail:</strong>&nbsp;{detail}
                <br />
                <br />

                {/* Tablet only */}
                <div class="is-hidden-mobile pt-2">
                    <div className="buttons">
                        <Link to={`/user/${uid}/session/${sid}/video-section/${i}`}  class="button is-primary is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                        {/*
                        <Link to={`/user/${uid}/session/${sid}/video-section/${i}/edit`}  class="button is-warning is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                        <button onClick={(e, ses) => onSelectVideoSectionForDeletion(e, obj)} class="button is-danger is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                        */}
                    </div>
                </div>

                {/* Mobile only */}
                <div class="is-hidden-tablet pt-2">
                    <div class="columns is-mobile pt-2">
                        <div class="column">
                            <Link to={`/user/${uid}/session/${sid}/video-section/${i}`}  class="button is-primary is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                        </div>
                        {/*
                        <div class="column">
                            <Link to={`/user/${uid}/session/${sid}/video-section/${i}/edit`}  class="button is-warning is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                        </div>
                        <div class="column">
                            <button onClick={(e, ses) => onSelectVideoSectionForDeletion(e, obj)} class="button is-danger is-small is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                        </div>
                        */}
                    </div>
                </div>
            </div>
        </div>
    );
}


export default UserSessionDetailForVideoSection;
